module.exports = __webpack_public_path__ + "static/media/Venipede_gaussian2.817d46b4.png";